<template>
  <div class="borderBox container">
    <div class="flex white_bg nav-div">
      <div
        class="flex item"
        :class="navIndex == 0 ? 'active' : ''"
        @click.stop="changeNav(0)"
      >
        <span>可提现</span>
        <img
          src="../../../assets/image/nsale/tabSelected.png"
          alt=""
          v-show="navIndex == 0"
        />
      </div>
      <div
        class="flex item"
        :class="navIndex == 1 ? 'active' : ''"
        @click.stop="changeNav(1)"
      >
        <span>预计奖励</span>
        <img
          src="../../../assets/image/nsale/tabSelected.png"
          alt=""
          v-show="navIndex == 1"
        />
      </div>
    </div>
    <div class="space-div"></div>
    <div class="borderBox date_select" v-if="navIndex == 0">
      <div class="flex borderBox white_bg inner-div">
        <span class="name">投保区间</span>
        <div class="flex right-div">
          <span
            class="date"
            :class="queryParams.startDate ? '' : 'gray'"
            @click.stop="showDatePicker(1)"
            >{{ queryParams.startDate || "开始日期" }}</span
          >
          <span class="zhi">至</span>
          <span
            class="date"
            :class="queryParams.endDate ? '' : 'gray'"
            @click.stop="showDatePicker(2)"
            >{{ queryParams.endDate || "结束日期" }}</span
          >
          <img
            src="../../../assets/image/nsale/del-icon.jpg"
            alt=""
            class="del"
            @click.stop="delDate"
          />
        </div>
      </div>
    </div>
    <!--可提现-->
    <div class="borderBox datalist-box">
      <p class="tips" v-if="!dataList || !dataList.length">
        {{ navIndex === 0 ? "暂无可提现记录~" : "暂无数据" }}
      </p>
      <div v-else>
        <template v-if="isTongjie == 'N'">
          <div
            class="white_bg borderBox list"
            v-for="(item, i) in dataList"
            :key="i"
          >
            <div class="flex title-div">
              <span class="ellipsis title">{{ item.productName }}</span>
              <span class="money"
                >{{ item.cooperationMode == 1 ? "积分金额" : "宣传奖励" }}: ￥{{
                  item.integral
                }}</span
              >
            </div>
            <div class="info">保单号：{{ item.policyNo }}</div>
            <div class="info">投保人：{{ item.holderName }}</div>
            <div class="info">投保时间：{{ item.issueDate }}</div>
            <div class="info">出单用户：{{ item.userName }}</div>
            <div class="info" v-if="navIndex == 1">
              未结算原因：{{ filterReason(item) }}
              <img
                src="../../../assets/image/nsale/ques.png"
                @click="
                  showTips(item.noSettleReason, item.policyId, item.policyNo)
                "
                class="ques"
                v-if="
                  (item.noSettleReason == '未到最早可计算积分日期' ||
                    item.noSettleReason == '无到账日期，请上传付款凭证' ||
                    item.noSettleReason == '请上传付款凭证' ||
                    item.noSettleReason == '未上传风险告知') &&
                    item.ownPolicy != 'N'
                "
              />
            </div>
          </div>
        </template>
        <template v-else>
          <template v-for="item in dataList">
            <div
              class="white_bg borderBox list"
              v-for="(item2, index) in item.policyDetailList"
              :key="index"
            >
              <div class="flex title-div">
                <span class="ellipsis title">{{ item2.productName }}</span>
                <span class="money"
                  >{{ item2.cooperationMode == 1 ? "积分金额" : "宣传奖励" }}:
                  ￥{{ item2.integral }}</span
                >
              </div>
              <div class="info">保单号：{{ item2.policyNo }}</div>
              <div class="info">投保人：{{ item2.holderName }}</div>
              <div class="info">投保时间：{{ item2.issueDate }}</div>
              <div class="info">出单用户：{{ item2.userName }}</div>
              <div class="info" v-if="navIndex == 1">
                未结算原因：{{ filterReason(item2) }}
                <img
                  src="../../../assets/image/nsale/ques.png"
                  @click="
                    showTips(
                      item2.noSettleReason,
                      item2.policyId,
                      item2.policyNo
                    )
                  "
                  class="ques"
                  v-if="
                    (item2.noSettleReason == '未到最早可计算积分日期' ||
                      item2.noSettleReason == '无到账日期，请上传付款凭证' ||
                      item2.noSettleReason == '请上传付款凭证' ||
                      item2.noSettleReason == '未上传风险告知') &&
                      item2.ownPolicy != 'N'
                  "
                />
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="flex borderBox white_bg btns-div" v-if="navIndex == 0">
      <div class="flex item" @click="showRule('jfrule')">
        <span>提现规则</span>
      </div>
      <div class="flex item main" @click.stop="withdrawEvt">
        <span>提现</span>
      </div>
    </div>
    <div class="renzheng-div" v-if="showModal">
      <div class="white_bg borderBox inner-div">
        <div class="title">
          应监管要求，未完成资质认证的用户积分不得提现及无法获得其他奖励，为保证您的利益不受损，请尽快完成资质认证。
        </div>
        <div class="flex btn-div">
          <div class="btn gray" @click.stop="showModal = false">放弃认证</div>
          <div class="btn" @click.stop="renzhengEvt">去认证</div>
        </div>
      </div>
    </div>
    <div class="renzheng-div" v-if="showTip">
      <div
        class="white_bg borderBox inner-div pL20"
        style="padding: 0 15px 30px;"
      >
        <div class="title">
          线上一年期无犹豫期的产品，缴费成功且保单生效后，积分结算日期=保单生效日+1
        </div>
        <div class="title mT20">
          线上一年期有犹豫期的产品，缴费成功且保单过犹豫期后，积分结算日期=犹豫期截止日+1
        </div>
        <div class="title mT20">
          线上长期险缴费成功且保单回访成功过犹豫期后，积分结算日期=犹豫期截止日+1
        </div>
        <div class="flex btn-div" style="justify-content: center;">
          <div class="btn gray" @click.stop="showTip = false">关闭</div>
        </div>
      </div>
    </div>
    <BurtDate
      ref="burtDate"
      @chooseDate="chooseDate"
      :dateType="isStartdate ? 'startDate' : 'endDate'"
      :queryParams="queryParams"
    />

    <cube-popup :visible="showDisabledWithdrawal" @mask-click="closePopup">
      <disabledWithdrawalPopup
        :limitedInfo="limitedInfo"
        @close="closePopup"
      ></disabledWithdrawalPopup>
    </cube-popup>

    <!-- 协议签署提示弹窗 -->
    <cube-popup :visible="showAgreementPop">
      <div class="agreement-popup_box">
        <p class="agreement-tips">
          {{ agreementTips }}
        </p>
        <div class="agreement-btn_box">
          <cube-button class="cancel_" @click="showAgreementPop = false">
            取消
          </cube-button>
          <cube-button class="btn_ sign_" @click="goSign">{{
            agreementType === "1"
              ? "去签署"
              : agreementType === "2"
              ? "确定"
              : "知道了"
          }}</cube-button>
        </div>
      </div>
    </cube-popup>
  </div>
</template>

<script>
import api from "@/utils/api.js";
import BurtDate from "./components/burtDate.vue";
import moment from "moment";
import disabledWithdrawalPopup from "./components/disabledWithdrawalPopup.vue";
let _keyStr =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
export default {
  data() {
    document.title = "可提现";
    return {
      userId: "",
      navIndex: 0,
      isStartdate: true, // 是开始时间还是结束时间
      queryParams: {
        startDate: "",
        endDate: ""
      },
      dataList: [],
      showModal: false,
      isTongjie: "",
      isTongjieNoFirst: "", // 是否统结非首层
      totalIntegral: "",
      taxPaymentAmount: "",
      authName: "",
      invoiceType: "",
      showTip: false,
      showDisabledWithdrawal: false, // 是否显示负积分弹窗
      limitedInfo: {}, // 负积分限制信息
      showAgreementPop: false, // 协议签署提示框
      approvalStatus: undefined, // 协议签署状态
      agreementTips: "", // 协议提示框文案
      agreementInfo: {} // 用户是否限制提现信息
    };
  },
  components: {
    BurtDate,
    disabledWithdrawalPopup
  },
  computed: {
    // 协议弹窗展示类型（1：个人/企业首层；2：企业非首层；3：个人首层签署，其下级存在未签署）
    agreementType() {
      let type = "1";
      if (!this.agreementInfo.isRoot && this.agreementInfo.cporpa === "1") {
        type = "2";
      } else if (
        this.agreementInfo.hasAgreement &&
        this.agreementInfo.showMark
      ) {
        type = "3";
      }
      this.setAgreementTips(type);
      return type;
    }
  },
  created() {
    let navIndex = sessionStorage.getItem("navIndex");
    this.navIndex = !navIndex || navIndex == "0" ? 0 : 1;
    this.userId = this.$route.query.userId;
    this.key = this.$route.query.key;
    this.key && localStorage.setItem("scOpenId", this.key);
    this.getData();

    // 查询是否可提现（保思协议签署相关）
    this.checkWithdrawalPermission();
    // 查询用户协议签署状态
    this.queryAgreement();
  },
  methods: {
    // 关闭负积分提示弹窗
    closePopup() {
      this.showDisabledWithdrawal = false;
    },
    // 查询当前账号是否负积分
    isDisabledWithdrawal() {
      return new Promise((resolve, reject) => {
        const userId = this.userId;
        api
          .isProhibitWithdrawal(userId)
          .then(res => {
            resolve(res.data.content);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 查询当前账号可提现积分情况
    getIncomeInfo() {
      return new Promise((resolve, reject) => {
        api
          .getIncomeInfo(this.userId)
          .then(res => {
            if (res.data.content) {
              const integral = Number(res.data.content.integral);
              resolve(integral);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    showTips(reason, id, no) {
      if (reason == "未到最早可计算积分日期") {
        this.showTip = true;
      } else if (
        reason == "无到账日期，请上传付款凭证" ||
        reason == "请上传付款凭证"
      ) {
        this.showRule("help");
      } else if (reason == "未上传风险告知") {
        sessionStorage.setItem("navIndex", 1);
        this.$router.push({
          path: "/bs/risk",
          query: { id, no }
        });
      }
    },
    changeNav(index) {
      if (this.navIndex != index) {
        this.navIndex = index;
        this.getData();
      }
    },
    delDate() {
      this.queryParams = {
        startDate: "",
        endDate: ""
      };
      this.getData();
    },
    // 选择日期
    showDatePicker(type = 1) {
      this.isStartdate = type == 1;
      this.$refs.burtDate.isShowCalendar = true;
    },
    chooseDate(date) {
      console.log(date, "------");
      if (this.isStartdate) {
        // 选择的开始时间
        if (
          date &&
          this.queryParams.endDate &&
          moment(this.queryParams.endDate).valueOf() < moment(date).valueOf()
        ) {
          window.$toast("开始日期不能大于结束日期");
          return;
        }
        this.queryParams.startDate = date
          ? moment(date).format("YYYY-MM-DD")
          : "";
      } else {
        if (
          date &&
          this.queryParams.startDate &&
          moment(this.queryParams.startDate).valueOf() > moment(date).valueOf()
        ) {
          window.$toast("开始日期不能大于结束日期");
          return;
        }
        this.queryParams.endDate = date
          ? moment(date).format("YYYY-MM-DD")
          : "";
      }

      // 可提现列表是否有负数积分
      let hasNegative = -1;
      if (this.isTongjie === "Y") {
        hasNegative = this.dataList.findIndex(item => {
          return item.policyDetailList.find(item1 => {
            return item1.integral < 0;
          });
        });
      } else {
        hasNegative = this.dataList.findIndex(item => {
          return item.integral < 0;
        });
      }
      // 可提现列表有负数积分 || 可提现总额小于0
      if (hasNegative >= 0 || this.totalIntegral < 0) {
        window.$toast("存在负数积分，请一起提现");
        this.queryParams.startDate = "";
        this.queryParams.endDate = "";
        return;
      }
      this.getData();
    },
    getData() {
      api
        .getIntegral({
          type: this.navIndex === 0 ? 2 : 1,
          userId: this.userId,
          startDate: this.queryParams.startDate,
          endDate: this.queryParams.endDate
        })
        .then(res => {
          let data = res.data.content || {};
          this.isTongjie = data.isTongjie;
          this.isTongjieNoFirst = data.isTongjieNoFirst;
          this.totalIntegral = data.totalIntegral;
          this.taxPaymentAmount = data.taxPaymentAmount;
          this.invoiceType = data.invoiceType;
          if (this.isTongjie === "Y") {
            this.dataList = data.pointTopDtoList || [];
          } else {
            this.dataList = data.pointDetailDtoList || [];
          }
        });
    },
    // 去提现
    async withdrawEvt() {
      // 如果实际提现积分小于0
      if (this.totalIntegral < 0) {
        // 判断是否限制提现
        let flag = true;
        // 如果是统结首层
        if (this.isTongjieNoFirst === "N") {
          const integral = await this.getIncomeInfo();
          flag = Number(integral) < 0;
        }
        if (flag) {
          // 显示积分限制提现弹窗
          this.showDisabledWithdrawal = true;
          this.limitedInfo = {
            limited: true,
            limitedType: 1,
            relevantLimiteAccount: null
          };
          return false;
        }
      } else if (this.totalIntegral > 0) {
        // 如果未签协议或者协议审核中，限制提现
				const isShowAgreement = (this.agreementInfo.cporpa === '1' && !this.agreementInfo.hasAgreementRoot) || (this.agreementInfo.cporpa === '2' && (!this.agreementInfo.hasAgreement || this.agreementInfo.showMark))
        if (isShowAgreement) {
          this.showAgreementPop = true;
          return;
        }
        // 调接口判断是否负积分限制提现
        let limitedInfo = await this.isDisabledWithdrawal();
        // 如果存在提现限制
        if (limitedInfo.limited && limitedInfo.limitedType === 2) {
          this.limitedInfo = limitedInfo;
          this.showDisabledWithdrawal = true;
          return;
        }
      }

      api
        .getRenzhengStatus({
          userId: this.userId
        })
        .then(res => {
          let data = res.data.content || "";
          this.authName = data;
          if (data != 1) {
            this.showModal = true;
            return;
          }
          if (!this.totalIntegral || Number(this.totalIntegral) <= 0) {
            this.$toast("提现金额不能小于0");
            return false;
          }
          this.$router.push({
            path: "/bs/withdrawscore",
            query: {
              userId: this.userId,
              totalIntegral: this.totalIntegral,
              taxPaymentAmount: this.taxPaymentAmount,
              invoiceType: this.invoiceType,
              isTongjieNoFirst: this.isTongjieNoFirst,
              ...this.queryParams
            }
          });
        });
    },
    // 认证
    renzhengEvt() {
      if (this.authName === "5") {
        // 认证中状态
        this.$router.push({
          path: "/bs/authResult",
          query: {
            isPass: this.authName
          }
        });
        return true;
      }
      const key = `${this.userId}${this.key}`;
      this.$router.push({
        path: "/bs/authentication",
        query: {
          authName: this.authName,
          key: this.encode(key)
        }
      });
    },
    encode(input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      const _utf8_encode = string => {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }
        }
        return utftext;
      };
      input = _utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output =
          output +
          _keyStr.charAt(enc1) +
          _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) +
          _keyStr.charAt(enc4);
      }
      return output;
    },
    showRule(type) {
      if (type == "jfrule") {
        sessionStorage.setItem("navIndex", 0);
      } else {
        sessionStorage.setItem("navIndex", 1);
      }
      this.$router.push({ path: "/bs/jfrule", query: { type } });
    },
    filterReason(item) {
      // 新增NosettleStatus的判断是保单未结算原因和冻结原因，去掉noSettleReason判断
      if (item.nosettleStatus) {
        return item.nosettleStatus;
      }

      if (item.isfreeze === "true") {
        return "请联系运营人员核实保单情况";
      }
    },
    // 设置协议提示框文案
    setAgreementTips(type) {
      let tips =
        "为了保证业务行为合法、公正、顺利进行,现保思用户需要签署《蝶系合作协议》，请上传对应文件并进行协议签字。";
      if (type === "2") {
        tips =
          "为保证业务行为合法、公正、顺利进行，现保思用户需要签署《蝶系合作协议》，请联系您的首层渠道进行协议签署。";
      } else if (type === "3") {
        tips =
          "由于您为统结用户，积分提现涉及到下级积分，现仍有未签署协议的下级，所以仍不可提现。";
      }
      this.agreementTips = tips;
    },
    // 判断是否可提现（保思协议签署相关）
    checkWithdrawalPermission() {
      api.checkWithdrawalPermission(this.userId).then(res => {
        const data = res.data;
        if (data.returnCode == "0000") {
          if (data.content) {
            this.agreementInfo = data.content;
          }
        }
      });
    },
    // 查询用户协议签署状态
    queryAgreement() {
      api.getWebuserAgreementByUserId(this.userId).then(res => {
        const data = res.data;
        if (data.returnCode === "0000" && data.content) {
          this.approvalStatus = data.content.approvalStatus;
        }
      });
    },
    // 跳转签署协议
    goSign() {
      if (this.agreementType === "3") {
        this.showAgreementPop = false;
        return;
      }
      let name =
        this.agreementInfo.cporpa === "2"
          ? "agreementList"
          : "agreementNotices";
      if (this.agreementInfo.cporpa === "1" && this.approvalStatus !== undefined) {
        name = "agreementSignResult";
      }
      this.$router.push({
        name,
        query: {
          userId: this.userId,
          cporpa: this.agreementInfo.cporpa,
          isOld: !this.agreementInfo.isNew
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.white_bg {
  background: #fff;
}
.borderBox {
  box-sizing: border-box;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.container {
  font-family: PingFangSC-Medium PingFang SC;
  background: #f9f9f9;
  min-height: 100vh;
  padding-bottom: 50px;
}
.nav-div {
  padding: 0 16px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  justify-content: center;
  .item {
    position: relative;
    justify-content: center;
    color: #373737;
    font-size: 13px;
    padding: 19px 0;
    &.active {
      img {
        width: 19px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 8px;
      }
    }
  }
  .item + .item {
    margin-left: 55px;
  }
}
.space-div {
  height: 51px;
}
.date_select {
  margin-top: 10px;
  padding: 0 20px;
  .inner-div {
    height: 40px;
    border-radius: 7px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    justify-content: space-between;
    padding: 0 15px;
    .right-div {
      font-size: 12px;
      .zhi {
        margin: 0 12px;
      }
      .date {
        &.gray {
          color: #ccc;
        }
      }
      img {
        width: 16px;
        margin-left: 28px;
      }
    }
  }
}
.datalist-box {
  padding: 0 20px;
  margin-bottom: 15px;
  .tips {
    margin-top: 15px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .list {
    margin-top: 15px;
    border-radius: 7px;
    padding: 15px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    .title-div {
      justify-content: space-between;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 3px;
      .title {
        max-width: calc(100% - 140px);
        text-align: left;
        font-weight: 500;
        color: #000000;
      }
      .money {
        font-size: 13px;
        color: #ff7c6d;
      }
    }
    .info {
      line-height: 22px;
      text-align: left;
      display: flex;
      align-items: center;
    }
  }
}
.btns-div {
  width: 100%;
  height: 50px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  .item {
    flex: 1;
    height: 36px;
    background: #f4f4f4;
    justify-content: center;
    align-items: center;
    color: #373737;
    border-radius: 8px;
    font-size: 13px;
    &.main {
      background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
      color: #fff;
    }
    img {
      width: 16px;
      height: auto;
      min-width: 16px;
      margin-right: 8px;
    }
  }
  .item + .item {
    margin-left: 5%;
  }
}
.accN {
  max-width: 280px;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  overflow: hidden;
}
.ellipsis3 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.renzheng-div {
  position: fixed;
  z-index: 20;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .inner-div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 332px;
    // height: 200px;
    background: #ffffff;
    border-radius: 7px;
    padding: 0 30px 30px;
    font-size: 15px;
    .title {
      margin-top: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
      text-align: left;
    }
    .mT20 {
      margin-top: 20px;
    }
    .pL20 {
      padding: 0 15px 30px;
    }
    .btn-div {
      justify-content: space-between;
      margin-top: 23px;
      .btn {
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        background: #ff7c6d;
        border-radius: 5px;
        color: #fff;
        padding: 0 36px;
        font-size: 12px;
        &.gray {
          background: #eaeaea;
          color: #666;
        }
      }
    }
  }
}
.ques {
  width: 11px;
  height: 11px;
  margin-left: 3px;
}

.agreement-popup_box {
  width: 331px;
  border-radius: 7px;
  padding: 32px 26px 22px;
  background-color: #ffffff;
  font-size: 15px;
  p {
    color: #333333;
    line-height: 25px;
  }
  .agreement-btn_box {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    .cube-btn {
      width: 126px;
      height: 40px;
      padding: 0;
      border-radius: 5px;
    }
    .cancel_ {
      background: #eaeaea;
      color: #666666;
    }
    .btn_ {
      background: #ff7c6d;
      color: #ffffff;
    }
    .confirm_ {
      width: 100%;
    }
  }
}
</style>
